"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __importDefault(require("./state"));
var color_1 = require("../utilities/color");
var navigation_button_1 = __importStar(require("../views/navigation-button"));
var game_area_1 = require("../utilities/game-area");
var PromoState = /** @class */ (function (_super) {
    __extends(PromoState, _super);
    function PromoState(app, client) {
        var _this = _super.call(this) || this;
        _this._app = app;
        _this._client = client;
        return _this;
    }
    Object.defineProperty(PromoState.prototype, "playButton", {
        get: function () {
            if (!this._playButton) {
                this._playButton = new PIXI.Graphics()
                    .beginFill(color_1.COLOR.WHITE)
                    .drawCircle(50, 50, 50)
                    .endFill()
                    .beginFill(color_1.COLOR.BLACK)
                    .moveTo(36, 30)
                    .lineTo(36, 70)
                    .lineTo(70, 50);
                this._playButton.interactive = true;
                this._playButton.on("pointerdown", this.onPlayVideo.bind(this));
                this._playButton.position.set((game_area_1.GAME_WIDTH - this._playButton.width) * 0.5, (game_area_1.GAME_HEIGHT - this._playButton.height) * 0.5);
            }
            return this._playButton;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoState.prototype, "videoSprite", {
        get: function () {
            if (!this._videoSprite) {
                this._videoSprite = new PIXI.Sprite();
                this._videoSprite.width = game_area_1.GAME_SAFE_AREA.width;
                this._videoSprite.height = game_area_1.GAME_SAFE_AREA.height;
                this._videoSprite.position.set(game_area_1.GAME_PADDING_X, game_area_1.GAME_PADDING_Y);
            }
            return this._videoSprite;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromoState.prototype, "closeButton", {
        get: function () {
            if (!this._closeButton) {
                this._closeButton = new navigation_button_1.default(this._app.loader.resources.ui.textures, navigation_button_1.NAVIGATION_BUTTON_TYPE.CLOSE, this.onClose.bind(this));
                this._closeButton.background.alpha = 0.3;
                this._closeButton.position.set(game_area_1.GAME_SAFE_AREA.right - this._closeButton.width - 12, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._closeButton;
        },
        enumerable: false,
        configurable: true
    });
    PromoState.prototype.didEnterFrom = function (previousState) {
        _super.prototype.didEnterFrom.call(this, previousState);
        this._app.stage.addChild(this.playButton);
    };
    PromoState.prototype.willExitTo = function (nextState) {
        _super.prototype.willExitTo.call(this, nextState);
        this._app.stage.removeChild(this.playButton);
        this._app.stage.removeChild(this.videoSprite);
        this._app.stage.removeChild(this.closeButton);
        this.videoSprite.texture.destroy(true);
    };
    PromoState.prototype.onPlayVideo = function () {
        var _this = this;
        this._app.stage.removeChild(this.playButton);
        this._app.stage.addChild(this.videoSprite);
        this._app.stage.addChild(this.closeButton);
        var texture = PIXI.Texture.from("assets/promo.mp4");
        var resource = texture.baseTexture.resource;
        var element = resource.source;
        element.playsInline = true;
        element.onended = function () {
            _this.onClose();
        };
        this.videoSprite.texture = texture;
    };
    PromoState.prototype.onClose = function () {
        this._client.dragon.status.showPromo = false;
        this._client.synchronize();
        this.stateMachine.pop();
    };
    return PromoState;
}(state_1.default));
exports.default = PromoState;
